import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Name:")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Exchange Rate:")
], -1)
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "row mb-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Create Elimination Report tab: ")
], -1)
const _hoisted_16 = { class: "col-md-6 pt-1" }
const _hoisted_17 = { class: "row mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", null, "Columns", -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-4\"><div class=\"col-md-6 required\"><label class=\"col-form-label-title\">Debit Sheet</label></div><div class=\"col-md-6 required\"><label class=\"col-form-label-title\">Credit Sheet</label></div></div>", 1)
const _hoisted_20 = { class: "row mb-4" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = { class: "col-md-9" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "row"
}
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = { class: "col-md-9" }
const _hoisted_30 = {
  key: 1,
  class: "sheet-option-pair"
}
const _hoisted_31 = { class: "col-md-6" }
const _hoisted_32 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_33 = { class: "row" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = { class: "col-md-9" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  key: 0,
  class: "row"
}
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = { class: "col-md-9" }
const _hoisted_40 = {
  key: 1,
  class: "sheet-option-pair"
}
const _hoisted_41 = { class: "row mb-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("b", null, "CWK Debit/Credit Amounts", -1)
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-4\"><div class=\"col-md-6 required\"><label class=\"col-form-label-title\">Debit Sheet</label></div><div class=\"col-md-6 required\"><label class=\"col-form-label-title\">Credit Sheet</label></div></div>", 1)
const _hoisted_44 = { class: "row mb-4" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-md-3" }
const _hoisted_49 = { class: "col-md-9" }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-md-3" }
const _hoisted_53 = { class: "col-md-9" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = {
  key: 0,
  class: "flex align-items-center"
}
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = { class: "col-md-9" }
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-md-3" }
const _hoisted_62 = { class: "col-md-9" }
const _hoisted_63 = { class: "row mb-4" }
const _hoisted_64 = { class: "col-md-6" }
const _hoisted_65 = { class: "row align-items-center" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title me-2" }, "CWK row:")
], -1)
const _hoisted_67 = { class: "col-md-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title me-2" }, "CWK figures in -ve?")
], -1)
const _hoisted_69 = { class: "col-md-1 pt-1" }
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = { class: "row align-items-center" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title me-2" }, "CWK row:")
], -1)
const _hoisted_73 = { class: "col-md-2" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title me-2" }, "CWK figures in -ve?")
], -1)
const _hoisted_75 = { class: "col-md-1 pt-1" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_77 = { class: "row mb-4" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_79 = { class: "d-flex col-md-6" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    onDeleteEvent: _ctx.deleteCompany,
                    renderDelete: (_ctx.identifier != null ? true : false),
                    isDeleting: _ctx.isDeleting
                  }, null, 8, ["onDeleteEvent", "renderDelete", "isDeleting"]),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_InputText, {
                                class: "p-inputtext",
                                type: "text",
                                maxlength: "100",
                                placeholder: "Name",
                                modelValue: _ctx.eliminationSetting.name,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.eliminationSetting.name) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.exchangeRate,
                                optionLabel: "name",
                                optionValue: "value",
                                placeholder: "-- Please Select --",
                                modelValue: _ctx.eliminationSetting.exchangeRate,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.eliminationSetting.exchangeRate) = $event))
                              }, null, 8, ["options", "modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_Checkbox, {
                                modelValue: _ctx.eliminationSetting.isAssociated,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.eliminationSetting.isAssociated) = $event)),
                                binary: true
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_Divider, null, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_19,
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_Dropdown, {
                                modelValue: _ctx.eliminationSetting.rpkDebitSheet,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.eliminationSetting.rpkDebitSheet) = $event)),
                                options: _ctx.sheets.filter((s) => s.type == 'RPK'),
                                placeholder: "Select a Sheet",
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                optionLabel: "code"
                              }, {
                                value: _withCtx((dropdownProps) => [
                                  (dropdownProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                          _createElementVNode("span", _hoisted_24, _toDisplayString(dropdownProps.value.code), 1),
                                          _createElementVNode("span", _hoisted_25, _toDisplayString(dropdownProps.value.name), 1)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(dropdownProps.placeholder), 1))
                                ]),
                                option: _withCtx((dropdownProps) => [
                                  (!_ctx.checkRpkCreditSheetExist(dropdownProps))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _createElementVNode("span", _hoisted_28, _toDisplayString(dropdownProps.option.code), 1),
                                        _createElementVNode("span", _hoisted_29, _toDisplayString(dropdownProps.option.name), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_30))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_Dropdown, {
                                modelValue: _ctx.eliminationSetting.rpkCreditSheet,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.eliminationSetting.rpkCreditSheet) = $event)),
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                optionLabel: "code",
                                options: _ctx.sheets.filter((s) => s.type == 'RPK'),
                                placeholder: "Select a Sheet"
                              }, {
                                value: _withCtx((dropdownProps) => [
                                  (dropdownProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _createElementVNode("div", _hoisted_33, [
                                          _createElementVNode("span", _hoisted_34, _toDisplayString(dropdownProps.value.code), 1),
                                          _createElementVNode("span", _hoisted_35, _toDisplayString(dropdownProps.value.name), 1)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(dropdownProps.placeholder), 1))
                                ]),
                                option: _withCtx((dropdownProps) => [
                                  (!_ctx.checkRpkDebitSheetExist(dropdownProps))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        _createElementVNode("span", _hoisted_38, _toDisplayString(dropdownProps.option.code), 1),
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(dropdownProps.option.name), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_40))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "options"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(_component_Divider, null, {
                              default: _withCtx(() => [
                                _hoisted_42
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_43,
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_Dropdown, {
                                modelValue: _ctx.eliminationSetting.cwkDebitSheet,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.eliminationSetting.cwkDebitSheet) = $event)),
                                options: _ctx.sheets.filter((s) => s.type == 'CWK'),
                                placeholder: "Select a Sheet",
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                optionLabel: "code"
                              }, {
                                value: _withCtx((dropdownProps) => [
                                  (dropdownProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        _createElementVNode("div", _hoisted_47, [
                                          _createElementVNode("span", _hoisted_48, _toDisplayString(dropdownProps.value.code), 1),
                                          _createElementVNode("span", _hoisted_49, _toDisplayString(dropdownProps.value.name), 1)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(dropdownProps.placeholder), 1))
                                ]),
                                option: _withCtx((dropdownProps) => [
                                  _createElementVNode("div", _hoisted_51, [
                                    _createElementVNode("span", _hoisted_52, _toDisplayString(dropdownProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_53, _toDisplayString(dropdownProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createVNode(_component_Dropdown, {
                                modelValue: _ctx.eliminationSetting.cwkCreditSheet,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.eliminationSetting.cwkCreditSheet) = $event)),
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                optionLabel: "code",
                                options: _ctx.sheets.filter((s) => s.type == 'CWK'),
                                placeholder: "Select a Sheet"
                              }, {
                                value: _withCtx((dropdownProps) => [
                                  (dropdownProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                        _createElementVNode("div", _hoisted_56, [
                                          _createElementVNode("span", _hoisted_57, _toDisplayString(dropdownProps.value.code), 1),
                                          _createElementVNode("span", _hoisted_58, _toDisplayString(dropdownProps.value.name), 1)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(dropdownProps.placeholder), 1))
                                ]),
                                option: _withCtx((dropdownProps) => [
                                  _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("span", _hoisted_61, _toDisplayString(dropdownProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_62, _toDisplayString(dropdownProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["modelValue", "options"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("div", _hoisted_65, [
                                _hoisted_66,
                                _createElementVNode("div", _hoisted_67, [
                                  _createVNode(_component_InputNumber, {
                                    placeholder: "Row",
                                    modelValue: _ctx.eliminationSetting.cwkDebitSheetRow,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.eliminationSetting.cwkDebitSheetRow) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _hoisted_68,
                                _createElementVNode("div", _hoisted_69, [
                                  _createVNode(_component_Checkbox, {
                                    modelValue: _ctx.eliminationSetting.isCwkDebitNegative,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.eliminationSetting.isCwkDebitNegative) = $event)),
                                    binary: true
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_70, [
                              _createElementVNode("div", _hoisted_71, [
                                _hoisted_72,
                                _createElementVNode("div", _hoisted_73, [
                                  _createVNode(_component_InputNumber, {
                                    placeholder: "Row",
                                    modelValue: _ctx.eliminationSetting.cwkCreditSheetRow,
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.eliminationSetting.cwkCreditSheetRow) = $event))
                                  }, null, 8, ["modelValue"])
                                ]),
                                _hoisted_74,
                                _createElementVNode("div", _hoisted_75, [
                                  _createVNode(_component_Checkbox, {
                                    modelValue: _ctx.eliminationSetting.isCwkCreditNegative,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.eliminationSetting.isCwkCreditNegative) = $event)),
                                    binary: true
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ]),
                          _hoisted_76,
                          _createElementVNode("div", _hoisted_77, [
                            _hoisted_78,
                            _createElementVNode("div", _hoisted_79, [
                              _createVNode(_component_Button, {
                                class: "p-button-sm",
                                disabled: _ctx.v$.eliminationSetting.$invalid || _ctx.isLoading,
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.identifier == null ? _ctx.save() : _ctx.update())),
                                label: "Save"
                              }, null, 8, ["disabled"]),
                              _hoisted_80,
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.cancel,
                                label: "Cancel"
                              }, null, 8, ["onClick"]),
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}